import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import IProduct from 'models/product';
import { FC } from 'react';
import { ILabelOptions } from './InputTextField';
import InputLabel from './InputLabel';
import MissingFieldHint from 'components/product/ProductUpdateForm/validation-context/MissingFieldHint';
import { ProductRuleFieldType } from 'components/product/ProductUpdateForm/validation-context/type';

interface BooleanFieldProps {
  readOnly?: boolean;
  labelOptions?: ILabelOptions;
  labelStyles?: React.CSSProperties;
  styles?: React.CSSProperties;
  name: keyof IProduct;
  state?: IProduct;
  setState?: React.Dispatch<React.SetStateAction<IProduct>>;
}

const BooleanField: FC<BooleanFieldProps> = ({ readOnly, labelOptions, labelStyles, styles, name, state, setState }) => {
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;

    const formattedValue = value ? value === 'true' : null;

    setState?.({ ...state, [name]: formattedValue });
  };

  return (
    <FormControl disabled={readOnly} component="fieldset" style={{ width: '100%', ...styles }}>
      {!!labelOptions && <InputLabel {...labelOptions} labelStyles={labelStyles} />}
      <RadioGroup
        id={String(name)}
        value={state?.[name]}
        name={name}
        style={{ flexDirection: 'row', gridGap: 16 }}
        onChange={handleRadioChange}
      >
        <FormControlLabel value={true} control={<Radio color="primary" />} label="Ja" />
        <FormControlLabel value={false} control={<Radio color="primary" />} label="Nej" />
        <FormControlLabel value={null} control={<Radio color="primary" />} label="Ej valt" />
      </RadioGroup>
      <MissingFieldHint field={name as ProductRuleFieldType} />
    </FormControl>
  );
};

export default BooleanField;
